import React from "react"

const Layout = ({ children }) => {
  return (
    <div className="allianz-foundation">
      {children}
    </div>
  )
}

export default Layout
